import { createContext } from 'react'

export const Custom = createContext(null)
